import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const scrollToTop = () => {
  const scrollingElement =
    document.scrollingElement || document.documentElement || document.body;

  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  scrollingElement.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

const scheduleScrollToTop = () => {
  scrollToTop();
  const animationFrame = window.requestAnimationFrame(scrollToTop);
  const retryDelays = [0, 50, 150, 350, 700];
  const timeouts = retryDelays.map((delay) =>
    window.setTimeout(scrollToTop, delay)
  );

  return () => {
    window.cancelAnimationFrame(animationFrame);
    timeouts.forEach(window.clearTimeout);
  };
};

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";

    return () => {
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, []);

  useEffect(() => {
    return scheduleScrollToTop();
  }, [location.key, location.pathname, location.search]);

  useEffect(() => {
    const handleInternalLinkClick = (event) => {
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.altKey ||
        event.ctrlKey ||
        event.shiftKey
      ) {
        return;
      }

      const target =
        event.target instanceof Element
          ? event.target
          : event.target.parentElement;
      const link = target?.closest("a[href]");

      if (!link || link.target === "_blank" || link.hasAttribute("download")) {
        return;
      }

      const destination = new URL(link.href, window.location.href);

      if (
        destination.origin === window.location.origin &&
        !destination.hash
      ) {
        scheduleScrollToTop();
      }
    };

    document.addEventListener("click", handleInternalLinkClick, true);

    return () => {
      document.removeEventListener("click", handleInternalLinkClick, true);
    };
  }, []);

  return null;
};

export default ScrollToTop;
